<nirby-dropdown-filter [items]="variablesItems" [filter]="true" [ngModel]="value" (ngModelChange)="emitChange($event)">
</nirby-dropdown-filter>
